import { Checkbox } from '@/shared/ui/checkbox';
import { Label } from '@/shared/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/shared/ui/dialog';
import { cn } from '@/shared/lib/cn';
import { PublicInviteRichText } from './public-invite-rich-text';

interface PublicInviteTermsCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  organizationName: string;
  linkTermsConditions?: string;
  termsAndConditions?: string;
  /** `passbook.backgroundColor` — substitui o amarelo default da Fixe pela cor da loja. */
  accentColor?: string;
}

/**
 * Resolução dinâmica idêntica ao legado (views/invite.ejs): `linkTermsConditions`
 * (link externo) e `termsAndConditions` (modal com texto) são mutuamente
 * exclusivos — nunca os dois ao mesmo tempo.
 */
export function PublicInviteTermsCheckbox({
  checked,
  onCheckedChange,
  organizationName,
  linkTermsConditions,
  termsAndConditions,
  accentColor,
}: PublicInviteTermsCheckboxProps) {
  const linkStyle = accentColor ? { color: accentColor } : undefined;
  const linkClassName = cn('underline underline-offset-2', !accentColor && 'text-primary');

  return (
    <div className="flex items-start gap-3">
      <Checkbox
        id="invite-terms"
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        className="mt-0.5"
      />
      <Label
        htmlFor="invite-terms"
        className="text-sm font-normal leading-snug text-muted-foreground"
      >
        Ao continuar, você concorda com os Termos e Condições de utilização do programa de
        fidelidade {organizationName}.{' '}
        {linkTermsConditions ? (
          <a
            href={linkTermsConditions}
            target="_blank"
            rel="noreferrer"
            className={linkClassName}
            style={linkStyle}
          >
            Acesse o link para ver nossos termos e condições
          </a>
        ) : termsAndConditions ? (
          <Dialog>
            <DialogTrigger asChild>
              <button type="button" className={linkClassName} style={linkStyle}>
                Ver termos e condições
              </button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Termos e Condições</DialogTitle>
              </DialogHeader>
              <PublicInviteRichText html={termsAndConditions} />
            </DialogContent>
          </Dialog>
        ) : null}
      </Label>
    </div>
  );
}
